import React, { Fragment } from 'react';
import { NavBar } from 'app-components';
import { CHAT_LINKS } from '../../../constants/common/miscellaneous';

const GAChatLink = props => {
    const {
        environment: {
            impersonation,
            impersonationDetails,
            links,
            flags: {
                isWebChatEnabled,
                isWebChatEnglishEnabled,
                isWebChatSpanishEnabled
            },
            language
        },
        user,
    } = props;

    //based on iex config
    var getConfigLanguage = () => {
        if(isWebChatEnabled && isWebChatEnglishEnabled && isWebChatSpanishEnabled) {
            return language;
        } else if(isWebChatEnabled && isWebChatEnglishEnabled) {
            return 'en';
        } else if(isWebChatEnabled && isWebChatSpanishEnabled) {
            return 'es';
        } else {
            return false;
        }
    };

    var configLanguage = getConfigLanguage();

    var getLink = () => {
      if(configLanguage === 'en') {
        if(user) {
          return CHAT_LINKS.CHAT_LOGIN_EN
        } else {
          return CHAT_LINKS.CHAT_NOT_LOGIN_EN
        } 
      } else if(configLanguage === 'es') {
        if(user) {
          return CHAT_LINKS.CHAT_LOGIN_ES
        } else {
          return CHAT_LINKS.CHAT_NOT_LOGIN_ES
        }
      }
      return ''
    }

    
    let urlReplacements, capUrl, fullName, userId, activeModuleName, activeModuleId, externalHouseholdCaseId, impersonatedUserType, impersonatedUsername;
    const landingPage = encodeURIComponent(window.location.href);

    if(user) {
        capUrl = `${window.location.host}/cap/consumer/view/${user.encryptedUserName}`;
        fullName = impersonation ? `${impersonationDetails.firstName} ${impersonationDetails.lastName}` : `${user.firstName} ${user.lastName}`; 
        userId = impersonation ? impersonationDetails.userId : user.userId;
        activeModuleName = user.activeModuleName;
        activeModuleId = user.activeModuleId;
        externalHouseholdCaseId = impersonation ? impersonationDetails.externalHouseholdCaseId : user.externalHouseholdCaseId; 
        impersonatedUserType = impersonation ? user.role : null;
        impersonatedUsername = impersonation ? user.userName : null;
        const username = sessionStorage.getItem('householdEmail') || null;
        let ani = sessionStorage.getItem('householdPhone') || null;

        if (ani !== null) {
            ani = ani.slice(0,10).padStart(10, '0');
        }

        const userInfo = encodeURIComponent(
            JSON.stringify({
                'UserID': userId,
                'activeModuleName':  activeModuleName,
                'activeModuleID': activeModuleId,
                'fullName':  fullName,
                'externalHouseholdCaseID': externalHouseholdCaseId,
                'capUrl': capUrl,
                'isSessionImpersonated': impersonation,
                'impersonatedUserType': impersonatedUserType,
                'impersonatedUsername': impersonatedUsername,
                'ani': ani,
                'username': username                
            })
        );
    
        urlReplacements = {
            landingPage,
            language: configLanguage,
            userInfo 
        };

    } else {
        urlReplacements = {
            landingPage,
            language: configLanguage
        };
    }

    const url = links[getLink()] ? (links[getLink()]).processReplacements(urlReplacements) : '';

    var width = 390;
    var height = 700;
    var left = window.screen.availWidth - width - 15;
    var top = 155;

    var windowFeatures = `left=${left},top=${top},width=${width},height=${height}`;

    const handler = () => {
        window.open(
            url,
            'popup',
            windowFeatures
        );
    };
    
    return (
        <Fragment>
            {
                configLanguage ?
                     <NavBar.SubMenuActionItem id='chat_link' labelId='gaep.menu.support.chat' onClickHandler={handler} />
                    :
                    null
            }    
        </Fragment>  
    );
};

export default GAChatLink;
